import {containersStore} from '@store/settings/containers/containers.store';
import {getContainersDataSource} from '@store/settings/containers/containers.requests';
import {getEntity} from '@ngneat/elf-entities';

export class ContainersQuery {
  store = containersStore;

  containers$ = getContainersDataSource.data$();

  containerById = (containerId: number) => this.store.query(getEntity(containerId));
}

export const containersQuery = new ContainersQuery();